import React, { PureComponent } from 'react';

import TaskGroupContainer from '../containers/task-group-container';

import TaskGroupHead from './task-group-head';

const Element = ({ id, name, color, assignees, archived, milestone, project, completed, hideAssignees, hideUtils }) => (
    <div className={'milestone-overview-head-item task-group' + (completed ? ' completed' : '')}>
        <TaskGroupHead
            id={id}
            name={name}
            color={color}
            archived={archived}
            completed={completed}
            projectId={project}
            draggable={false}
            assignees={assignees}
            milestone={milestone}
            hideAssignees={hideAssignees}
            hideUtils={hideUtils}
        />
    </div>
)

export default class MilestoneOverviewHeadItem extends PureComponent {
    render() {
        if (this.props.completed) {
            return <Element {...this.props} />
        }

        return <TaskGroupContainer id={this.props.id}><Element /></TaskGroupContainer>;
    }
}
